export default __webpack_public_path__ + "static/Hoy_no_Circula-5ec37da9d1021386806aa2e2e99e8974.png";